import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { User } from 'src/app/domain/user';
import { Permissions } from 'src/app/domain/user-profile/permissions';
import { environment } from 'src/environments/environment';

@Injectable()
export class CoreData {
    
    private PAGE_NAME = `${environment.appCode}_PAGE_NAME_` + environment.name;
    private SCANNED_POMPE_CODE = `${environment.appCode}_SCANNED_POMPE_CODE_${environment.name}`;
    private SCANNED_CASSETTE_CODE = `${environment.appCode}_SCANNED_CASSETTE_CODE_${environment.name}`;
    private SCANNED_ID = `${environment.appCode}_SCANNED_ID_${environment.name}`;
    private TOKEN = `${environment.appCode}_TOKEN_` + environment.name;
    private WITH_OAUTH = `${environment.appCode}_WITH_OAUTH_` + environment.name;
    private REFRESH_TOKEN = `${environment.appCode}_REFRESH_TOKEN_` + environment.name;
    private WITH_DONE = `${environment.appCode}_WITH_DONE_${environment.name}`;
    private SCOPE = `${environment.appCode}_SCOPE`;
    private ROLE_AND_PERMISSIONS = `${environment.appCode}_ROLE_AND_PERMISSIONS`;

    set Token(token: string | null) {
        if (token)
            localStorage.setItem(this.TOKEN, token);
    }

    get Token() {
        return localStorage.getItem(this.TOKEN);
    }

    get RefreshToken() {
        return localStorage.getItem(this.REFRESH_TOKEN) as string;
    }

    set RefreshToken(token: string) {
        localStorage.setItem(this.REFRESH_TOKEN, token);
    }

    get SelectedScopeCode() {
        return localStorage.getItem(this.SCOPE)!;
    }

    set SelectedScopeCode(scope: string) {
        localStorage.setItem(this.SCOPE, scope);
    }

    get RoleAndPermissions() {
        if (localStorage.getItem(this.ROLE_AND_PERMISSIONS)) {
            return JSON.parse(atob(localStorage.getItem(this.ROLE_AND_PERMISSIONS)!));
        }
        return [];
    }

    set RoleAndPermissions(ui: Permissions[]) {
        if (ui) {
            localStorage.setItem(this.ROLE_AND_PERMISSIONS, btoa(JSON.stringify(ui)));
        } else {
            localStorage.removeItem(this.ROLE_AND_PERMISSIONS);
        }
    }

    get CurrentPageName() {
        return localStorage.getItem(this.PAGE_NAME)!;
    }
    set CurrentPageName(name: string) {
        localStorage.setItem(this.PAGE_NAME, name);
    }

    get ScannedBarCode() {
        return localStorage.getItem(this.SCANNED_CASSETTE_CODE) as string;
    }

    set ScannedBarCode(token: string) {
        localStorage.setItem(this.SCANNED_CASSETTE_CODE, token);
    }

    get ScannedId() {
        return localStorage.getItem(this.SCANNED_ID) as string;
    }
    
    set ScannedId(token: string) {
        localStorage.setItem(this.SCANNED_ID, token);
    }

    get WithDone() {
        return JSON.parse(localStorage.getItem(this.WITH_DONE) ?? 'false');
    }
    
    set WithDone(withDone: boolean) {
        localStorage.setItem(this.WITH_DONE, `${withDone}`);
    }
    
    getUserFromJWTToken(): User | undefined {
        const u = new User();
        if (this.Token) {

            const decodedToken = jwtDecode(this.Token) as any
            if (decodedToken) {
                u.Email = decodedToken.email;
                u.FirstName = decodedToken.given_name;
                u.LastName = decodedToken.display_name.split(' ')[1];
            }
            return u;
        }
        return undefined;
    }

    clearToken(): void {
        localStorage.removeItem(this.TOKEN);
    }

    get IsMobile() {
        return window.navigator.userAgent.includes('Mobi');
    }

    get User(): User | undefined {
        if (!this.Token)
            return undefined
        return this.getUserFromJWTToken();
    }

    public get IsLoggedIn() {
        return this.Token && this.Token !== '';
    }
}
